export default __webpack_public_path__ + "static/media/img--pool-1.6bccdf5e.jpg";